import { Link } from "@novaescola/eva-react-v2/lib/Link";
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { useInView } from "../../hooks/useInView";

const RelatedContent = ({ contents }) => {
  let sufixRelatedExternal = 1;
  let featuredImage = '';

  const relatedContentRef = useRef(null);

  const isInView = useInView(relatedContentRef);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const previewEventSent = window.dataLayer.filter(
      (el) =>
        el.label &&
        el.label ===
          "SITE: Click - fichas de recomposição - Bloco Lateral Relacionadas - bloco visualizado"
    );

    if (isInView && previewEventSent.length === 0) {
      window.dataLayer.push({
        event: "block_visualization",
        label:
          "SITE: Click - fichas de recomposição - Bloco Lateral Relacionadas - bloco visualizado",
      });
    }
  }, [isInView]);

  return (
    <div className="related-content">
      <Typography variant="title" size={6} asChild className="eva-color-inst-700 eva-mb-04">
        <p ref={relatedContentRef}>Relacionadas</p>
      </Typography>
      <ul className="eva-mb-08">        
        {contents.map((content, index) => {
          if (!content.featuredImage) {
            featuredImage = `https://novaescola-content-gatsbyjs.s3.amazonaws.com/images/relacionadas${sufixRelatedExternal}.jpg`;
            sufixRelatedExternal++;
          }

          if (content.external) {
            return (
              <li key={`relatedContent${index}`} className="item eva-body-3">
                <Link
                  variant="preto"
                  className="item-link eva-font-14"
                  key={index}
                  href={content.url}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: "cta_click",
                      category: "link",
                      label: `SITE: Click - fichas de recomposição - destaque relacionadas ${index + 1}`
                    })
                  }}
                >                  
                  <img
                    src={content.featuredImage || featuredImage}
                    alt={content.title}
                    width={80}
                    height={80}
                    loading="lazy"
                  />
                  <span>{content.title}</span>
                </Link>                
              </li>
            );
          } else {
            return (
              <li key={`relatedContent${index}`} className="item eva-body-3">                
                <Link
                  href={content.url}                  
                  variant="preto"
                  className="item-link eva-font-14"
                  key={index}
                  onClick={() => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: "cta_click",
                      category: "link",
                      label: `SITE: Click - fichas de recomposição - destaque relacionadas ${index + 1}`
                    })
                  }}
                >
                  <img
                    src={content.featuredImage || featuredImage}
                    alt={content.title}
                    width={80}
                    height={80}
                    loading="lazy"
                    onError={(event) => { event.target.src = "https://nova-escola-producao.s3.amazonaws.com/e75cd25f-6b5d-4638-87e7-b5bf5d915aa6.webp" }}
                  />
                  <span>{content.title}</span>             
                </Link>
              </li>
            );
          }
        })}
      </ul>
    </div>
  );
};

RelatedContent.defaultProps = {
  contents: [],
};

RelatedContent.propTypes = {
  contents: PropTypes.arrayOf(PropTypes.object),
};

export default RelatedContent;
